/* ============================================================
   SupliPets — global.js
   Cross-cutting behavior: drawers, AJAX cart, announcement,
   predictive search, accordions, carousel, quiz.
   Guarded so each block is a no-op when its markup is absent.
   ============================================================ */
(function () {
  'use strict';

  var root = document.documentElement;
  var lang = (root.getAttribute('lang') || 'es-MX');
  var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';
  function money(cents) {
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* -------------------- Drawer helper -------------------- */
  var openDrawers = [];
  function openDrawer(el, opener) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    if (opener) opener.setAttribute('aria-expanded', 'true');
    el._opener = opener || null;
    openDrawers.push(el);
    var focusable = el.querySelector('input, button, [href], select, textarea');
    if (focusable) setTimeout(function () { focusable.focus(); }, 40);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (el._opener) el._opener.setAttribute('aria-expanded', 'false');
    openDrawers = openDrawers.filter(function (d) { return d !== el; });
    if (!openDrawers.length) document.body.classList.remove('overflow-hidden');
    if (el._opener) el._opener.focus();
  }
  function closeAll() { openDrawers.slice().forEach(closeDrawer); }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cart-open],[data-menu-open],[data-search-open]');
    if (openBtn) {
      e.preventDefault();
      if (openBtn.hasAttribute('data-cart-open')) openDrawer(document.querySelector('[data-cart-drawer]'), openBtn);
      else if (openBtn.hasAttribute('data-menu-open')) openDrawer(document.querySelector('[data-menu-drawer]'), openBtn);
      else if (openBtn.hasAttribute('data-search-open')) {
        openDrawer(document.querySelector('[data-search-overlay]'), openBtn);
        var si = document.querySelector('[data-search-input]');
        if (si) setTimeout(function () { si.focus(); }, 40);
      }
      return;
    }
    var closeBtn = e.target.closest('[data-cart-close],[data-menu-close],[data-search-close]');
    if (closeBtn) {
      e.preventDefault();
      closeDrawer(closeBtn.closest('.drawer, .search-overlay'));
      return;
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openDrawers.length) closeDrawer(openDrawers[openDrawers.length - 1]);
  });

  /* -------------------- Announcement rotation -------------------- */
  (function () {
    var bar = document.querySelector('[data-announcement]');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.announcement-bar__message');
    if (msgs.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    var speed = (parseFloat(bar.getAttribute('data-speed')) || 3.2) * 1000;
    setInterval(function () {
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, speed);
  })();

  /* -------------------- Cart (AJAX /cart/*.js) -------------------- */
  var CART = {
    strings: (window.SupliPetsCartStrings || {}),
    refresh: function () {
      return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { CART.render(cart); return cart; });
    },
    render: function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
      document.querySelectorAll('[data-cart-count-drawer]').forEach(function (el) { el.textContent = cart.item_count; });
      var itemsWrap = document.querySelector('[data-cart-items]');
      var footer = document.querySelector('[data-cart-footer]');
      if (itemsWrap) itemsWrap.innerHTML = CART.itemsHTML(cart);
      if (footer) {
        if (cart.item_count > 0) {
          footer.hidden = false;
          var sub = footer.querySelector('[data-cart-subtotal]');
          if (sub) sub.textContent = money(cart.total_price);
        } else {
          footer.hidden = true;
        }
      }
    },
    itemsHTML: function (cart) {
      var S = CART.strings;
      if (!cart.items.length) {
        return '<div class="cart-empty">' +
          '<p class="cart-empty__title">' + (S.empty || 'Tu carrito está vacío') + '</p>' +
          '<p>' + (S.empty_message || '') + '</p>' +
          '<button type="button" class="btn btn--cta" data-cart-close>' + (S.continue_shopping || 'Seguir comprando') + '</button></div>';
      }
      return cart.items.map(function (item) {
        var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_128x$1') + '" alt="" width="64" height="64" loading="lazy">' : '';
        var variant = (item.product_has_only_default_variant) ? '' : '<p class="cart-item__variant">' + item.variant_title + '</p>';
        return '<div class="cart-item" data-cart-item data-key="' + item.key + '">' +
          '<div class="cart-item__media">' + img + '</div>' +
          '<div class="cart-item__info">' +
          '<p class="cart-item__name">' + item.product_title + '</p>' + variant +
          '<p class="cart-item__price">' + money(item.final_price) + ' &times; ' + item.quantity + '</p>' +
          '</div>' +
          '<button type="button" class="cart-item__remove" data-cart-remove data-key="' + item.key + '">' + (S.remove || 'Quitar') + '</button>' +
          '</div>';
      }).join('');
    },
    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function (cart) { CART.render(cart); return cart; });
    },
    add: function (formData, btn) {
      if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: formData })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { /* error, e.g. sold out */ return res; }
          return CART.refresh().then(function () {
            openDrawer(document.querySelector('[data-cart-drawer]'));
            return res;
          });
        })
        .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
    }
  };
  window.SupliPetsCart = CART;

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) { e.preventDefault(); CART.change(rm.getAttribute('data-key'), 0); return; }
  });

  // Product form add-to-cart (drawer)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    CART.add(new FormData(form), form.querySelector('[type="submit"]'));
  });

  /* -------------------- Predictive search -------------------- */
  (function () {
    var input = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-search-results]');
    if (!input || !results) return;
    var timer, controller;
    function render(products) {
      if (!products.length) { results.innerHTML = ''; return; }
      results.innerHTML = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? '<div class="predictive-card__media"><img src="' + p.featured_image.url + '" alt="" loading="lazy"></div>'
          : '<div class="predictive-card__media"></div>';
        return '<a href="' + p.url + '" class="predictive-card">' + img +
          '<p class="predictive-card__title">' + p.title + '</p></a>';
      }).join('');
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (!q) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        if (controller) controller.abort();
        controller = new AbortController();
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { signal: controller.signal, headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) { render((data.resources && data.resources.results && data.resources.results.products) || []); })
          .catch(function () {});
      }, 220);
    });
  })();

  /* -------------------- Accordions (one open at a time per group) -------------------- */
  document.querySelectorAll('[data-accordion-group]').forEach(function (group) {
    group.addEventListener('toggle', function (e) {
      var item = e.target;
      if (item.tagName !== 'DETAILS' || !item.open) return;
      group.querySelectorAll('details[open]').forEach(function (d) { if (d !== item) d.open = false; });
    }, true);
  });

  /* -------------------- Review carousel -------------------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(track.children);
    var perView = parseInt(carousel.getAttribute('data-per-view') || '3', 10);
    var index = 0;
    function clamp() {
      if (window.matchMedia('(max-width: 860px)').matches) perView = 1;
      else perView = parseInt(carousel.getAttribute('data-per-view') || '3', 10);
    }
    function update() {
      clamp();
      slides.forEach(function (s, i) {
        var visible = i >= index && i < index + perView;
        s.style.display = visible ? '' : 'none';
      });
    }
    carousel.addEventListener('click', function (e) {
      if (e.target.closest('[data-carousel-prev]')) { index = (index - 1 + slides.length) % slides.length; update(); }
      if (e.target.closest('[data-carousel-next]')) { index = (index + 1) % slides.length; update(); }
    });
    window.addEventListener('resize', update);
    update();
  });

  /* -------------------- Quiz modal (multi-step) -------------------- */
  (function () {
    var modal = document.querySelector('[data-quiz]');
    if (!modal) return;
    var steps = Array.prototype.slice.call(modal.querySelectorAll('[data-quiz-step]'));
    var result = modal.querySelector('[data-quiz-result]');
    var current = 0;
    function show(n) {
      steps.forEach(function (s, i) { s.hidden = i !== n; });
      if (result) result.hidden = true;
    }
    function finish() {
      steps.forEach(function (s) { s.hidden = true; });
      if (result) result.hidden = false;
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-quiz-open]')) { e.preventDefault(); current = 0; show(0); openDrawer(modal, e.target.closest('[data-quiz-open]')); }
      if (e.target.closest('[data-quiz-close]')) { e.preventDefault(); closeDrawer(modal); }
      var opt = e.target.closest('[data-quiz-option]');
      if (opt && modal.contains(opt)) {
        current++;
        if (current >= steps.length) finish(); else show(current);
      }
    });
  })();

  /* -------------------- Reveal on scroll -------------------- */
  (function () {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (e) { e.classList.add('is-revealed'); }); return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-revealed'); obs.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { obs.observe(e); });
  })();

})();
